<li class="list-group-item">
  <div class="zdb-help-group-item">
    <div class="zdb-help-item-question" *ngIf="helpItem.question">{{ helpItem.question }}</div>
    <div class="zdb-help-item-answer"> {{ helpItem.answer }} </div>
  </div>
</li>
